import { useTranslation } from "react-i18next";

import { ConfirmDialog } from "./ConfirmDialog";

import type { WorkflowTransitionConfirmMessage } from "~/hooks/useWorkflowStepTransition";

interface Props {
  message: WorkflowTransitionConfirmMessage | null;
  onConfirm: () => void;
  onDismiss: () => void;
}

export function WorkflowTransitionConfirmDialog({
  message,
  onConfirm,
  onDismiss,
}: Props) {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      open={message !== null}
      onOpenChange={onDismiss}
      title={message?.title ?? ""}
      description={message?.description ?? ""}
      cancelLabel={t(($) => $.commons.workflow.cancel)}
      confirmLabel={t(($) => $.commons.buttons.continue)}
      onConfirm={onConfirm}
    />
  );
}
